import { useQueryClient, QueryKey } from "@tanstack/react-query";

const useQueryData = <Data>(queryKey: QueryKey) => {
  const queryClient = useQueryClient();

  return queryClient.getQueryData<Data>(queryKey);
};

export default useQueryData;
